<template>
  <b-card
    bg-variant="light"
    class="border-0"
    header-class="border-bottom-0 d-flex justify-content-end"
  >
    <b-alert :show="errors.any()" variant="danger" class="px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <template v-slot:header>
      <b-btn
        class="p-0"
        variant="link"
        :title="$t('shared.remove')"
        v-b-tooltip
        @click="emitRemove"
      >
        <font-awesome-icon icon="trash-alt" class="text-danger align-middle"/>
      </b-btn>
    </template>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ $t('shared.name') }}
              <required-symbol/>
            </b-input-group-prepend>

            <b-form-input
              dir="auto"
              :name="$t('shared.name')"
              v-validate="'required'"
              v-model="model.name"
            />
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ $t('account.nationalCode') }}
              <required-symbol/>
            </b-input-group-prepend>

            <b-form-input
              dir="ltr"
              :name="$t('account.nationalCode')"
              v-validate="'required|digits:10'"
              v-model="model.nationalCode"
            />
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group :prepend="$t('shared.position')">
            <b-form-input dir="auto" v-model="model.position"/>
          </b-input-group>
        </b-form-group>

        <b-form-group class="mb-md-0">
          <date-picker
            disable-dates-before-today
            :label="$t('shared.expireDate')"
            v-model="model.expireDate"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <uploader
            :label="$t('shared.signatureImage')"
            :name="$t('shared.signatureImage')"
            bg-variant="white"
            v-validate="'required'"
            required
            v-model="model.image"
          />
        </b-form-group>

        <b-form-group class="mb-0">
          <c-switch
            variant="3d"
            color="success"
            :text="$t('shared.insertUnderContract')"
            v-model="model.contractSignatory"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { Switch as cSwitch, DatePicker, Uploader } from '@/components/shared'

export default {
  name: 'Item',
  components: {
    cSwitch,
    DatePicker,
    Uploader
  },
  props: {
    value: Object
  },
  computed: {
    model:{
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    emitRemove () {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.$emit('remove', this.model.id)
      }
    },
    validateAll () {
      return this.$validator.validateAll()
    }
  }
}
</script>